export const locales = {
  modals: {
      "CLOSE": {
        ru: "Закрыть",
        en: "Close"
      },
      "NEXT": {
        ru: "Далее",
        en: "Next"
      },
      "PREV": {
        ru: "Назад",
        en: "Previous"
      },
      "MODAL": {
        ru: "Вы можете закрыть окно по кнопке ESC",
        en: "You can close this modal by pressing the ESC button"
      },
      "ERROR": {
        ru: "Что-то пошло не так, попробуйте позже x(",
        en: "Something went wrong, please try again later x("
      },
      "TIMEOUT": {
        ru: "Превышено время ожидания запроса x(",
        en: "Network error x("
      },
      "IMAGE_ERROR": {
        ru: "Ошибка загрузки картинки x(",
        en: "Image loading error x("
      },
      "ELEMENT_NOT_FOUND": {
        ru: "Ошибка загрузки элемента x(",
        en: "Element loading error x("
      },
      "AJAX_NOT_FOUND": {
        ru: "404: ошибка загрузки контента x(",
        en: "404: content loading error x("
      },
      "AJAX_FORBIDDEN": {
        ru: "403: Ошибка загрузки контента x(",
        en: "403: content loading error x("
      },
      "IFRAME_ERROR": {
        ru: "Ошибка загрузки фрейма x(",
        en: "Frame loading error x("
      },
  },
  forms: {
      "CUSTOM_EMPTY": {
        ru: "Собственное сообщение об ошибке незаполненного поля",
        en: "Custom error of empty field"
      },
      "CUSTOM_INVALID": {
        ru: "Собственное сообщение об ошибке формата поля",
        en: "Custom error of invalid field"
      },
      "CUSTOM_VALID": {
        ru: "Собственное сообщение об успешном заполнении поля",
        en: "Custom message about valid field"
      },
      "VALID_FIELD": {
        ru: "Поле заполнено верно",
        en: "Valid field"
      },
      "NETWORK_ERROR": {
        ru: "Ошибка получения данных с сервера. Попробуйте позже.",
        en: "Error retrieving data from the server. Try again later."
      },
    "FILE_UPLOAD_VALID": {
      ru: "Загружаемый файл может принимать следующие расширения: pdf, png, jpeg, jpg, gif, webp. Ограничения по размеру файла - 10 МБ.",
    },
      "FILE_UPLOAD_ERROR_FORMAT": {
        ru: "Загружаемый файл может принимать следующие расширения: pdf, png, jpeg, jpg, gif, webp. Ограничения по размеру файла - 10 МБ. Неверный формат файла",
        en: "Invalid file format"
      },
      "FILE_UPLOAD_ERROR_SIZE": {
        ru: "Загружаемый файл может принимать следующие расширения: pdf, png, jpeg, jpg, gif, webp. Ограничения по размеру файла - 10 МБ. Слишком большой файл",
        en: "File too large"
      },
      "FILE_UPLOAD_ERROR_MAX": {
        ru: "Загружено максимальное количество файлов",
        en: "Maximum number of files uploaded"
      },
      "EMPTY_FIELD": {
        ru: "Заполните поле",
        en: "Fill in the field"
      },
      "INVALID_FILE": {
        ru: "Прикрепите файл верного формата",
        en: "Attach a valid file"
      },
      "INVALID_FIELD": {
        ru: "Неверно",
        en: "Invalid"
      },
      "INVALID_EMAIL": {
        ru: "Неверный email",
        en: "Invalid email"
      },
      "EMPTY_CHECKBOX": {
        ru: "Пожалуйста, поставьте галочку",
        en: "Fill the checkbox please"
      },
      "INVALID_CAPTCHA": {
        ru: "Пройдите captcha",
        en: "Pass captcha"
      },
      "FILE_SIZE_BYTE": {
        ru: "Байт",
        en: "Byte"
      },
      "FILE_SIZE_KB": {
        ru: "Кб",
        en: "Kb"
      },
      "FILE_SIZE_MB": {
        ru: "Мб",
        en: "Mb"
      },
      "FILE_SIZE_GB": {
        ru: "Гб",
        en: "Gb"
      },
      "FILE_SIZE_TB": {
        ru: "Tб",
        en: "Tb"
      },
  }
}
